import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject, Observable, Subscription, timer } from 'rxjs';


@Component({
  selector: 'mui-hero-current-time',
  templateUrl: './mui-hero-current-time.component.html',
  styleUrls: ['./mui-hero-current-time.component.scss']
})
export class MuiHeroCurrentTimeComponent implements OnInit, OnDestroy {
  @Input() timeFormat? = 'hh:mm A';
  @Input() dateFormat? = 'dddd, MMMM D, YYYY';

  subscriptions: Subscription = new Subscription();

  private _time: BehaviorSubject<{ date: string; clock: string }> = new BehaviorSubject(this.getFormattedTime());

  get time$(): Observable<{ date: string; clock: string }> {
    return this._time.asObservable();
  }

  ngOnInit(): void {
    this._time.next(this.getFormattedTime());

    const now = moment();
    const secondsUntilNextMinute = 60 - now.seconds();

    this.subscriptions.add(timer(secondsUntilNextMinute * 1_000, 60_000).subscribe(() => {
      this._time.next(this.getFormattedTime());
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private getFormattedTime(): { date: string; clock: string } {
    const now = moment();
    return {
      date: now.format(this.dateFormat),
      clock: now.format(this.timeFormat)
    };
  }
}
